const events = [
    {
        name: 'event 1',
        start: {
            year: 2018,
            month: 0,
            day: 19
        },
        end: {
            year: 2018,
            month: 0,
            day: 20
        }
    },
    {
        name: 'event 2',
        start: {
            year: 2018,
            month: 2,
            day: 20
        },
        end: {
            year: 2018,
            month: 2,
            day: 21
        }
    },
    {
        name: 'event 3',
        start: {
            year: 2018,
            month: 2,
            day: 27
        },
        end: {
            year: 2018,
            month: 2,
            day: 28
        }
    },
    {
        name: 'event 4',
        start: {
            year: 2018,
            month: 3,
            day: 24
        },
        end: {
            year: 2018,
            month: 3,
            day: 25
        }
    },
    {
        name: 'event 5',
        start: {
            year: 2018,
            month: 4,
            day: 21
        },
        end: {
            year: 2018,
            month: 3,
            day: 24
        }
    },
    {
        name: 'event 6',
        start: {
            year: 2018,
            month: 7,
            day: 2
        },
        end: {
            year: 2018,
            month: 7,
            day: 5
        }
    },
    {
        name: 'event 7',
        start: {
            year: 2018,
            month: 7,
            day: 2
        },
        end: {
            year: 2018,
            month: 9,
            day: 11
        }
    },
    {
        name: 'event 8',
        start: {
            year: 2018,
            month: 7,
            day: 6
        },
        end: {
            year: 2018,
            month: 7,
            day: 12
        }
    }
];

const months = ['may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec', ''];

class Timeline {
    constructor() {
        this.timeline = document.getElementById('timeline-js');
        this.timelineIndicator = document.getElementById('timeline-indicator-js');
        this.timeEvents = document.getElementsByClassName('event-js');
        this.timelineDimesions = undefined;

        this.initial();
    }
    initial() {
        this.addEventListeners();
    }
    addEventListeners() {
        window.addEventListener('resize', () => {
            this.timelineDimesions = this.timeline.getBoundingClientRect();
            this.updateMarkers();
        });

        document.addEventListener('DOMContentLoaded', () => {
            setTimeout(() => {
                this.timelineDimesions = this.timeline.getBoundingClientRect();
                this.createMarkers();
                this.setTimeRanges();
                this.handleHighlighting();
            }, 150);
        });
    }
    createMarkers(timelineDimesions) {
        const timelineWidth = this.timelineDimesions.width - 1;
        
        for (let index = 0; index < months.length; index += 1) {
            const marker = document.createElement('span');
            marker.classList.add('timeline-marker');

            const label = marker.textContent;
            marker.textContent = `${months[index]}`;

            this.timeline.appendChild(marker);
            marker.style.left = `${(timelineWidth / (months.length - 1) * index)}px`;
        }
    }
    updateMarkers() {
        const timelineWidth = this.timelineDimesions.width - 1;
        const markers = document.getElementsByClassName('timeline-marker');

        for (let index = 0; index < months.length; index += 1) {
            markers[index].style.left = `${(timelineWidth / (months.length - 1) * index)}px`;
        }
    }
    setIndicator() {
        this.timelineIndicator.style.left = `${this.timelineDimesions.left}px`;
    }
    handleHighlighting() {
        const lines = document.getElementsByClassName('timeline-event');
        [...this.timeEvents].forEach((event, index) => {
            event.addEventListener('mouseenter', () => {
                lines[index].classList.add('timeline-event--active');
            });
        });
        [...this.timeEvents].forEach((event, index) => {
            event.addEventListener('mouseleave', () => {
                lines[index].classList.remove('timeline-event--active');
            });
        });
    }
    setTimeRanges() {
        const timelineStart = new Date(2018, 0, 1);
        const timelineEnd = new Date(2018, 10, 1);
        const normalizeValue = value =>
            (value - timelineStart) / (timelineEnd - timelineStart);

        events.forEach((event, index) => {
            const [start, end] = [
                new Date(event.start.year, event.start.month, event.start.day),
                new Date(event.end.year, event.end.month, event.end.day)
            ];

            const startPoint = normalizeValue(start.getTime());
            const endPoint = normalizeValue(end.getTime());

            const eventLine = document.createElement('span');
            eventLine.classList.add('timeline-event');

            eventLine.addEventListener('mouseenter', event => {
                this.timeEvents[index].classList.add('table-layout__item--active');
            });
            eventLine.addEventListener('mouseleave', event => {
                this.timeEvents[index].classList.remove('table-layout__item--active');
            });

            this.timeline.appendChild(eventLine);
            eventLine.style.left = `${100 * startPoint}%`;

            if (events[index].name === 'event 1') {
                eventLine.style.top = `${38}%`;
            } else if (events[index].name === 'event 2') {
                eventLine.style.top = `${38}%`;
            } else if (events[index].name === 'event 3') {
                eventLine.style.top = `${38}%`;
            } else if (events[index].name === 'event 4') {
                eventLine.style.top = `${38}%`;
            } else if (events[index].name === 'event 5') {
                eventLine.style.top = `${38}%`;
            } else if (events[index].name === 'event 6') {
                eventLine.style.top = `${15}%`;
            } else if (events[index].name === 'event 7') {
                eventLine.style.top = `${38}%`;
            } else if (events[index].name === 'event 8') {
                eventLine.style.top = `${60}%`;
            } 

            if (
                events[index].name === 'event 1'
                || events[index].name === 'event 2'
                || events[index].name === 'event 3'
                || events[index].name === 'event 4'
                || events[index].name === 'event 5'
            ) {
                eventLine.style.borderRadius = '50%';
                eventLine.style.height = '8px';
                eventLine.style.width = '8px';
            } else {
                eventLine.style.width = `${100 * (endPoint - startPoint)}%`;
            }
        });

        const now = new Date();
        // this.timelineIndicator.style.left = `${100 * normalizeValue(now)}%`;
        this.timelineIndicator.style.left = `${2}%`;
    }
}

export default Timeline;



// WEBPACK FOOTER //
// ./src/modules/snippets/Timeline.js